import { useState, useEffect } from 'react';
import { TICKER_SYMBOLS, FALLBACK_STOCKS } from '../data';

// Key comes from .env (REACT_APP_FINNHUB_KEY); never commit it to the repo.
const TICKER_API_KEY = process.env.REACT_APP_FINNHUB_KEY;

const fetchStock = async (symbol) => {
  if (!TICKER_API_KEY) return null;
  try {
    const res = await fetch(
      `https://api.finnhub.io/api/v1/quote?symbol=${symbol}&token=${TICKER_API_KEY}`
    );
    const data = await res.json();
    if (!data.c || !data.pc) return null;
    return { symbol, price: data.c, previousClose: data.pc };
  } catch {
    return null;
  }
};

// Live stock quotes, refreshed every minute. Falls back to static sample data.
export const useTickerData = () => {
  const [stocks, setStocks] = useState(FALLBACK_STOCKS);
  const [lastUpdated, setLastUpdated] = useState(new Date());

  useEffect(() => {
    let isCancelled = false;

    const refresh = async () => {
      const results = await Promise.all(TICKER_SYMBOLS.map(fetchStock));
      const fresh = results.filter(Boolean);
      if (!isCancelled && fresh.length > 0) {
        setStocks(fresh);
        setLastUpdated(new Date());
      }
    };

    refresh();
    const intervalId = setInterval(refresh, 60000);

    return () => {
      isCancelled = true;
      clearInterval(intervalId);
    };
  }, []);

  return { stocks, lastUpdated };
};
